
import React, { useState, useRef, useEffect, useMemo } from "react";
import { toast } from 'react-toastify';
import LeftNav from "../components/common/LeftNav";
import TopNav from "../components/common/TopNav";
import LeadAnalytics from "../../Admin/components/Charts/LeadAnalytics";
import SourceAnalytics from "../../Admin/components/Charts/SourceAnalytics";
import { Modal, Form, Button } from "react-bootstrap";
import "../assets/styles/Webadmindashboard.css";
import {createPortal} from "react-dom";
import "../assets/styles/dashboard.css";
import "../assets/styles/CRMFilterModal.css";
import analyticsService from "../../services/analyticsService";

// Images
import totalleads from "../assets/img/totalleads.svg";
import sitevisit from "../assets/img/sitevisit.svg";
import invoicesent from "../assets/img/invoicesent.svg";
import bookinglead from "../assets/img/bookingleads.svg";
import activeleads from "../assets/img/activeleads.svg";
import prospectleads from "../assets/img/prospectleads.svg";
import export1 from "../assets/img/export.svg";
import filter1 from "../assets/img/filter1.svg";
import close from "../assets/img/close-square.svg";
import calendar from "../assets/img/calendar.svg";
import up from "../assets/img/up.svg";
import down from "../assets/img/down.svg"

import popularbuilder1 from "../assets/img/popularbuilder1.svg";
import popularagents1 from "../assets/img/popularagents1.svg";
import popularagencies1 from "../assets/img/popularagencies1.svg";
import popularprojects1 from "../assets/img/popularprojects1.svg";
import popularlocations1 from "../assets/img/popularlocations1.svg";
import propertytypes1 from "../assets/img/propertytypes1.svg";
import communitytypes1 from "../assets/img/communitytypes1.svg";
import propertyspecs1 from "../assets/img/propertyspecs1.svg";
import { useNavigate } from "react-router-dom";


export default function Dashboard() {
  // Time range state (matches React Native app)
  const [timeRange, setTimeRange] = useState('This Month');
  const [isFilterModalVisible, setFilterModalVisible] = useState(false);
  const [activeTab, setActiveTab] = useState('Dashboard');

  // Backend integration states (matches React Native app)
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dashboardData, setDashboardData] = useState(null);
  const [popularCounts, setPopularCounts] = useState(null);

  // PDF generation state
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);

  // User Analytics chart states (matches React Native app)
  const [chartData, setChartData] = useState([]);

  // Custom date filter states (matching mobile app exactly)
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [customStartDate, setCustomStartDate] = useState(null);
  const [customEndDate, setCustomEndDate] = useState(null);

  const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0, width: 0 });


  // 📅 Custom Date Picker States
  const [isDatePickerVisible, setIsDatePickerVisible] = useState(false);
  const [currentDateType, setCurrentDateType] = useState("");
  const [selectedDayIdx, setSelectedDayIdx] = useState(0);
  const [selectedMonthIdx, setSelectedMonthIdx] = useState(0);
  const [selectedYearIdx, setSelectedYearIdx] = useState(0);
    const [openDropdown, setOpenDropdown] = useState(null);
 
  const toggleDropdown = (name) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };
 
 
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  const startYear = 2025;
  const endYear = new Date().getFullYear() + 20;
  const years = Array.from(
    { length: endYear - startYear + 1 },
    (_, i) => (startYear + i).toString()
  );
 
  // ✅ Function to calculate days in month with leap year
  const getDaysInMonth = (monthIdx, year) => {
    return new Date(year, monthIdx + 1, 0).getDate();
  };
 
  // ✅ Memoized days array based on selected month + year
  const days = useMemo(() => {
    const y = parseInt(years[selectedYearIdx] || new Date().getFullYear());
    const m = selectedMonthIdx >= 0 ? selectedMonthIdx : new Date().getMonth();
    const totalDays = getDaysInMonth(m, y);
 
    // clamp selected day if overflow (e.g., 31 Jan → Feb → 28)
    if (selectedDayIdx >= totalDays) {
      setSelectedDayIdx(totalDays - 1);
    }
 
    return Array.from({ length: totalDays }, (_, i) =>
      (i + 1).toString().padStart(2, "0")
    );
  }, [selectedMonthIdx, selectedYearIdx, years, selectedDayIdx]);
 
  const dayRef = useRef(null);
  const monthRef = useRef(null);
  const yearRef = useRef(null);
 
const openDatePicker = (type, e) => {
  setCurrentDateType(type);
 
  // save position of clicked element
  const rect = e.currentTarget.getBoundingClientRect();
  setPickerPosition({
    top: rect.top + window.scrollY,  // position below field
    left: rect.left + window.scrollX,
    width: rect.width
  });
 
  const savedDate = type === 'start' ? startDate : endDate;
  let dayIdx, monthIdx, yearIdx;
 
  if (savedDate) {
    const [d, m, y] = savedDate.split(" ");
    dayIdx = parseInt(d, 10) - 1;
    monthIdx = months.indexOf(m);
    yearIdx = years.indexOf(y);
  } else {
    const today = new Date();
    const d = today.getDate().toString().padStart(2, "0");
    const m = months[today.getMonth()];
    const y = today.getFullYear().toString();
    dayIdx = parseInt(d, 10) - 1;
    monthIdx = months.indexOf(m);
    yearIdx = years.indexOf(y);
  }
 
  setSelectedDayIdx(dayIdx >= 0 ? dayIdx : 0);
  setSelectedMonthIdx(monthIdx >= 0 ? monthIdx : 0);
  setSelectedYearIdx(yearIdx >= 0 ? yearIdx : 0);
 
  setIsDatePickerVisible(true);
};
 
 
  // 📅 scroll to selected index when opening date picker
  useEffect(() => {
    if (!isDatePickerVisible) return;
 
    const scrollToIndex = (ref, index) => {
      if (!ref.current) return;
      ref.current.scrollTop = index * ITEM_HEIGHT;
    };
 
    requestAnimationFrame(() => {
      scrollToIndex(dayRef, selectedDayIdx);
      scrollToIndex(monthRef, selectedMonthIdx);
      scrollToIndex(yearRef, selectedYearIdx);
    });
  }, [isDatePickerVisible, selectedDayIdx, selectedMonthIdx, selectedYearIdx]);
 
  // Confirm Date Selection (matching mobile app exactly)
  const handleSaveDate = () => {
    const day = days[selectedDayIdx] ?? days[0];
    const month = months[selectedMonthIdx] ?? months[0];
    const year = years[selectedYearIdx] ?? years[0];
    const picked = `${day} ${month} ${year}`;
    const selectedParsed = parseDisplayDate(picked);

    if (currentDateType === 'start') {
      if (endDate) {
        const endParsed = parseDisplayDate(endDate);
        if (selectedParsed && endParsed && selectedParsed > endParsed) {
          toast.warning('Invalid Date: Start date cannot be after end date.');
          setIsDatePickerVisible(false);
          return;
        }
        if (selectedParsed && endParsed) {
          const maxEnd = new Date(selectedParsed);
          maxEnd.setFullYear(maxEnd.getFullYear() + 1);
          if (new Date(endParsed) > maxEnd) {
            setEndDate('');
            toast.warning('Date Range Limit: Range cannot exceed 1 year. Please re-select end date.');
          }
        }
      }
      setStartDate(picked);
    } else if (currentDateType === 'end') {
      if (startDate) {
        const startParsed = parseDisplayDate(startDate);
        if (startParsed && selectedParsed && selectedParsed < startParsed) {
          toast.warning('Invalid Date: End date cannot be before start date.');
          setIsDatePickerVisible(false);
          return;
        }
        if (startParsed && selectedParsed) {
          const maxEnd = new Date(startParsed);
          maxEnd.setFullYear(maxEnd.getFullYear() + 1);
          if (new Date(selectedParsed) > maxEnd) {
            toast.warning('Date Range Limit: Range cannot exceed 1 year from start date.');
            setIsDatePickerVisible(false);
            return;
          }
        }
      }
      setEndDate(picked);
    }

    setIsDatePickerVisible(false);
  };
 
  const ITEM_HEIGHT = 40; // must match your CSS
  let scrollTimeout = null;
 
  const handleScroll = (ref, setIndex, itemCount) => {
    if (!ref.current) return;
    const { scrollTop } = ref.current;
    const index = Math.round(scrollTop / ITEM_HEIGHT);
 
    if (index >= 0 && index < itemCount) {
      setIndex(index);
    }
 
    if (scrollTimeout) clearTimeout(scrollTimeout);
 
    scrollTimeout = setTimeout(() => {
      if (!ref.current) return;
      const snapIndex = Math.round(ref.current.scrollTop / ITEM_HEIGHT);
      const clamped = Math.max(0, Math.min(snapIndex, itemCount - 1));
 
      ref.current.scrollTo({
        top: clamped * ITEM_HEIGHT,
        behavior: "smooth",
      });
 
      setIndex(clamped);
    }, 150);
  };
 
  // Old filters state removed - now using individual state variables
  // Parse "DD Mon YYYY" or "DD Month YYYY" to "YYYY-MM-DD" for API (matching mobile app exactly)
  const parseDisplayDate = (dateStr) => {
    if (!dateStr) return null;
    try {
      const parts = dateStr.split(' ');
      if (parts.length !== 3) return null;
      const day = parseInt(parts[0]);
      const monthName = parts[1];
      const year = parseInt(parts[2]);

      const monthMap = {
        'Jan': 0, 'January': 0, 'Feb': 1, 'February': 1, 'Mar': 2, 'March': 2,
        'Apr': 3, 'April': 3, 'May': 4, 'Jun': 5, 'June': 5,
        'Jul': 6, 'July': 6, 'Aug': 7, 'August': 7, 'Sep': 8, 'September': 8,
        'Oct': 9, 'October': 9, 'Nov': 10, 'November': 10, 'Dec': 11, 'December': 11
      };

      const month = monthMap[monthName];
      if (month === undefined) return null;

      // Build ISO string directly — avoid toISOString() which shifts to UTC and can give previous day
      return `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    } catch (error) {
      console.error('Date parsing error:', error);
      return null;
    }
  };

  // Format date for display (matching mobile app exactly)
  const formatDisplayDate = (year, month, day) => {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                       'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${day} ${monthNames[month]} ${year}`;
  };

  const handleClearFilters = () => {
    setStartDate('');
    setEndDate('');
    setCustomStartDate(null);
    setCustomEndDate(null);
    setOpenDropdown(null);
    setFilterModalVisible(false);
    // Re-fetch with default timeRange
    fetchDashboardData(timeRange, null, null);
    console.log("Filters cleared");
  };
 
  // Fetch dashboard data function (matches React Native app exactly)
  const fetchDashboardData = async (range, apiStartDate, apiEndDate) => {
    setLoading(true);
    try {
      const [dashRes, chartRes, popularRes] = await Promise.all([
        analyticsService.getDashboardAnalytics(range, apiStartDate, apiEndDate),
        analyticsService.getUserAnalyticsChart(range, { startDate: apiStartDate, endDate: apiEndDate }),
        analyticsService.getPopularListCounts(apiStartDate, apiEndDate)
      ]);

      // apiUtils wraps response: res.data may be { data: actual } or actual directly
      const unwrap = (res) => res.success ? (res.data?.data !== undefined ? res.data.data : res.data) : null;

      const dashPayload = unwrap(dashRes);
      if (dashPayload) setDashboardData(dashPayload);

      const chartPayload = unwrap(chartRes);
      if (Array.isArray(chartPayload)) setChartData(chartPayload);

      const popularPayload = unwrap(popularRes);
      if (popularPayload) setPopularCounts(popularPayload);

      setError(null);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      setError(error.message || 'Failed to load dashboard data');
    } finally {
      setLoading(false);
    }
  };

  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState("This Month");
  const [showFilterModal, setShowFilterModal] = useState(false);

  // Load dashboard data on mount and when timeRange changes (matching mobile app exactly)
  useEffect(() => {
    // Only fetch via timeRange when no custom dates are set
    if (!customStartDate || !customEndDate) {
      fetchDashboardData(timeRange, null, null);
    }
  }, [timeRange]);

  // Re-fetch dashboard data when custom dates change
  useEffect(() => {
    if (customStartDate && customEndDate) {
      fetchDashboardData(timeRange, customStartDate, customEndDate);
    }
  }, [customStartDate, customEndDate]);


  // Helper function to get dashboard data values with fallbacks
  const getDashboardValue = (key) => {
    return dashboardData?.[key] || 0;
  };

  // Function to get dynamic time range display text (matches React Native app)
  const getTimeRangeDisplayText = () => {
    if (customStartDate && customEndDate && startDate && endDate) {
      return `${startDate} - ${endDate}`;
    }

    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.toLocaleString('default', { month: 'long' });

    // Get previous month
    const previousMonthDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const previousMonth = previousMonthDate.toLocaleString('default', { month: 'long' });

    if (timeRange === 'Life Time') {
      return `2025 - ${currentYear}`;
    } else if (timeRange === 'This Month') {
      return currentMonth;
    } else if (timeRange === 'Previous Month') {
      return previousMonth;
    }
    return currentYear.toString();
  };

  // Handle time range press (matching mobile app exactly)
  const handleTimeRangePress = (range) => {
    // Clear custom date filters when switching to preset range
    setCustomStartDate(null);
    setCustomEndDate(null);
    setStartDate('');
    setEndDate('');
    setTimeRange(range);
    setSelectedTab(range);
    // Re-fetch data with new time range
    fetchDashboardData(range, null, null);
  };


  // Admin dashboard stat cards configuration (matches React Native app)
  const statConfig = [
    { label: "Total Users", key: "total_users", img: totalleads },
    { label: "Total Builders", key: "total_builders", img: activeleads },
    { label: "Total Agents", key: "total_agents", img: prospectleads },
    { label: "Total Agencies", key: "total_agencies", img: bookinglead },
    { label: "Total Projects", key: "total_projects", img: invoicesent },
  ];

  // Clear filter handler
 

  // Apply filter handler (matching mobile app exactly)
  const handleApplyFilters = () => {
    const apiStart = parseDisplayDate(startDate);
    const apiEnd = parseDisplayDate(endDate);

    if (startDate && !apiStart) {
      toast.warning('Invalid Date: Please select a valid start date.');
      return;
    }
    if (endDate && !apiEnd) {
      toast.warning('Invalid Date: Please select a valid end date.');
      return;
    }
    if (apiStart && apiEnd && apiStart > apiEnd) {
      toast.warning('Invalid Range: Start date must be before end date.');
      return;
    }

    if (apiStart && apiEnd) {
      // Store custom dates and clear timeRange
      setCustomStartDate(apiStart);
      setCustomEndDate(apiEnd);
      setFilterModalVisible(false);
      setOpenDropdown(null);
      setShowFilterModal(false);
      fetchDashboardData(null, apiStart, apiEnd);
    } else if (apiStart || apiEnd) {
      toast.warning('Incomplete: Please select both start and end dates.');
    } else {
      // No dates selected, just close modal
      setFilterModalVisible(false);
      setOpenDropdown(null);
      setShowFilterModal(false);
    }
    console.log("Applied Filters:", { startDate, endDate, apiStart, apiEnd });
  };

  const handleDownloadReport = async () => {
    try {
      if (!dashboardData) {
        toast.info('Dashboard data is not loaded yet. Please wait.');
        return;
      }

      setIsGeneratingPDF(true);

      const currentDate = new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });

      // Fetch top 5 of each popular list for the selected time range
      const timeRangeFilter = timeRange && timeRange !== 'All Time' ? timeRange : undefined;
      const popularFilters = { page: 1, per_page: 5, time_range: timeRangeFilter };

      const [
        buildersRes, agentsRes, agenciesRes, projectsRes,
        locationsRes, propertyTypesRes, communityTypesRes, specsRes
      ] = await Promise.all([
        analyticsService.getPopularBuilders(popularFilters),
        analyticsService.getPopularAgents(popularFilters),
        analyticsService.getPopularAgencies(popularFilters),
        analyticsService.getPopularProjects(popularFilters),
        analyticsService.getPopularLocations(popularFilters),
        analyticsService.getPopularPropertyTypes(popularFilters),
        analyticsService.getPopularCommunityTypes(popularFilters),
        analyticsService.getPopularSpecs(popularFilters),
      ]);

      const topBuilders = buildersRes?.data?.items || [];
      const topAgents = agentsRes?.data?.items || [];
      const topAgencies = agenciesRes?.data?.items || [];
      const topProjects = projectsRes?.data?.items || [];
      const topLocations = locationsRes?.data?.items || [];
      const topPropertyTypes = propertyTypesRes?.data?.items || [];
      const topCommunityTypes = communityTypesRes?.data?.items || [];
      const topSpecs = specsRes?.data?.items || [];

      const stats = [
        { label: 'Total Users', value: dashboardData.total_users || 0, color: '#6F70FA' },
        { label: 'Total Builders', value: dashboardData.total_builders || 0, color: '#4CAF50' },
        { label: 'Total Agents', value: dashboardData.total_agents || 0, color: '#FF9800' },
        { label: 'Total Agencies', value: dashboardData.total_agencies || 0, color: '#2196F3' },
        { label: 'Total Projects', value: dashboardData.total_projects || 0, color: '#9C27B0' },
      ];

      const subscriptionStats = [
        { label: 'Subscribed Builders', value: dashboardData.subscribed_builders || 0, color: '#4CAF50' },
        { label: 'Subscribed Agents', value: dashboardData.subscribed_agents || 0, color: '#FF9800' },
        { label: 'Subscribed Agencies', value: dashboardData.subscribed_agencies || 0, color: '#2196F3' },
        { label: 'Unsubscribed Builders', value: dashboardData.unsubscribed_builders || 0, color: '#EF5350' },
        { label: 'Unsubscribed Agents', value: dashboardData.unsubscribed_agents || 0, color: '#FF7043' },
        { label: 'Unsubscribed Agencies', value: dashboardData.unsubscribed_agencies || 0, color: '#AB47BC' },
      ];

      const revenueStats = [
        { label: 'Total Revenue', value: `₹${(dashboardData.total_revenue || 0).toLocaleString()}`, color: '#4CAF50' },
        { label: 'Invoices Raised', value: dashboardData.total_invoices_raised || 0, color: '#FF9800' },
        { label: 'Invoices Fulfilled', value: dashboardData.invoices_fulfilled || 0, color: '#2196F3' },
      ];

      // Build bar charts using table-based layout (works reliably in html2pdf.js)
      const buildBarChart = (items, maxVal) => {
        const BAR_MAX_H = 130;
        return `
          <table style="width:100%;border-collapse:collapse;background:#F8F9FC;border-radius:12px;border:1px solid #E5E7EB;">
            <tr>
              ${items.map(it => {
                const h = Math.max(Math.round((it.value / maxVal) * BAR_MAX_H), 4);
                const spacer = BAR_MAX_H - h;
                return `
                  <td style="text-align:center;padding:10px 6px 8px;vertical-align:bottom;width:${Math.floor(100/items.length)}%;">
                    <div style="font-size:13px;font-weight:700;color:#333;margin-bottom:4px;">${it.value}</div>
                    <div style="height:${spacer}px;"></div>
                    <div style="height:${h}px;background:${it.color};border-radius:5px 5px 0 0;margin:0 auto;width:36px;"></div>
                    <div style="font-size:9px;color:#666;margin-top:5px;white-space:nowrap;">${it.name.length > 11 ? it.name.slice(0,11)+'…' : it.name}</div>
                  </td>`;
              }).join('')}
            </tr>
          </table>`;
      };

      const userTypes = [
        { name: 'Builders', value: dashboardData.total_builders || 0, color: '#4CAF50' },
        { name: 'Agents',   value: dashboardData.total_agents || 0,   color: '#FF9800' },
        { name: 'Agencies', value: dashboardData.total_agencies || 0, color: '#2196F3' },
      ];
      const subTypes = [
        { name: 'Sub. Builders',   value: dashboardData.subscribed_builders || 0,   color: '#4CAF50' },
        { name: 'Sub. Agents',     value: dashboardData.subscribed_agents || 0,     color: '#FF9800' },
        { name: 'Sub. Agencies',   value: dashboardData.subscribed_agencies || 0,   color: '#2196F3' },
        { name: 'Unsub. Builders', value: dashboardData.unsubscribed_builders || 0, color: '#EF5350' },
        { name: 'Unsub. Agents',   value: dashboardData.unsubscribed_agents || 0,   color: '#FF7043' },
        { name: 'Unsub. Agencies', value: dashboardData.unsubscribed_agencies || 0, color: '#AB47BC' },
      ];
      const maxUserVal = Math.max(...userTypes.map(u => u.value), 1);
      const maxSubVal  = Math.max(...subTypes.map(s => s.value), 1);

      // Build stat cards as an HTML table row (3-per-row)
      const buildStatGrid = (items) => {
        const rows = [];
        for (let i = 0; i < items.length; i += 3) {
          const chunk = items.slice(i, i + 3);
          while (chunk.length < 3) chunk.push(null);
          rows.push(`
            <tr>
              ${chunk.map(s => s
                ? `<td style="width:33%;padding:6px;">
                    <div style="background:#F8F9FC;border-radius:10px;padding:16px;text-align:center;border:1px solid #E5E7EB;">
                      <div style="font-size:26px;font-weight:700;color:${s.color};margin-bottom:4px;">${s.value}</div>
                      <div style="font-size:10px;color:#666;text-transform:uppercase;letter-spacing:0.5px;">${s.label}</div>
                    </div>
                  </td>`
                : `<td style="width:33%;padding:6px;"></td>`
              ).join('')}
            </tr>`);
        }
        return `<table style="width:100%;border-collapse:collapse;">${rows.join('')}</table>`;
      };

      const totalSub = (dashboardData.subscribed_builders||0)+(dashboardData.subscribed_agents||0)+(dashboardData.subscribed_agencies||0);
      const totalUnsub = (dashboardData.unsubscribed_builders||0)+(dashboardData.unsubscribed_agents||0)+(dashboardData.unsubscribed_agencies||0);
      const subRate = dashboardData.total_users > 0 ? Math.round(totalSub / dashboardData.total_users * 100) : 0;

      const buildPopularTable = (headers, rows) => `
        <table style="width:100%;border-collapse:collapse;margin-top:8px;margin-bottom:8px;">
          <thead>
            <tr>${headers.map((h,i) => `<th style="background:#6F70FA;color:#fff;padding:8px 10px;font-size:11px;text-align:left;font-weight:600;${i===0?'border-radius:6px 0 0 0;':''}${i===headers.length-1?'border-radius:0 6px 0 0;':''}">${h}</th>`).join('')}</tr>
          </thead>
          <tbody>${rows}</tbody>
        </table>`;

      const htmlContent = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="UTF-8">
          <style>
            * { margin:0; padding:0; box-sizing:border-box; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
            body { font-family:'Helvetica Neue',Arial,sans-serif; padding:28px; color:#333; line-height:1.5; background:#fff; }
            .section { margin-bottom:22px; }
            .section-title { font-size:15px; font-weight:600; color:#6F70FA; margin-bottom:12px; border-bottom:2px solid #E5E7EB; padding-bottom:7px; }
            .pt td { padding:7px 10px; font-size:11px; color:#333; border-bottom:1px solid #EEE; }
            .pt tr:nth-child(even) td { background:#F8F9FC; }
            .rank { font-weight:700; color:#6F70FA; }
            .page-break { page-break-before:always; }
          </style>
        </head>
        <body>

          <!-- HEADER -->
          <div style="text-align:center;margin-bottom:28px;border-bottom:3px solid #6F70FA;padding-bottom:18px;">
            <div style="font-size:30px;font-weight:700;color:#6F70FA;margin-bottom:6px;">REBAX</div>
            <div style="font-size:21px;font-weight:600;color:#1E1E1E;margin-bottom:4px;">Admin Dashboard Report</div>
            <div style="font-size:13px;color:#666;margin-bottom:12px;">Platform Analytics &amp; Statistics</div>
            <div style="background:#6F70FA;color:#fff;padding:10px 22px;border-radius:8px;display:inline-block;font-weight:600;font-size:13px;">${timeRange}</div>
          </div>

          <!-- PLATFORM OVERVIEW -->
          <div class="section">
            <div class="section-title">Platform Overview</div>
            ${buildStatGrid(stats)}
          </div>

          <!-- USER DISTRIBUTION -->
          <div class="section">
            <div class="section-title">User Distribution</div>
            ${buildBarChart(userTypes, maxUserVal)}
            <div style="text-align:center;margin-top:10px;">
              ${userTypes.map(ut => `<span style="display:inline-block;margin:0 10px;font-size:11px;"><span style="display:inline-block;width:11px;height:11px;background:${ut.color};border-radius:3px;margin-right:5px;vertical-align:middle;"></span>${ut.name}</span>`).join('')}
            </div>
          </div>

          <!-- SUBSCRIPTION ANALYTICS -->
          <div class="section">
            <div class="section-title">Subscription Analytics</div>
            ${buildStatGrid(subscriptionStats)}
            <div style="margin-top:14px;">${buildBarChart(subTypes, maxSubVal)}</div>
            <table style="width:100%;border-collapse:collapse;background:#6F70FA;border-radius:8px;margin-top:16px;">
              <tr>
                <td style="text-align:center;padding:14px;color:#fff;">
                  <div style="font-size:22px;font-weight:700;">${totalSub}</div>
                  <div style="font-size:10px;opacity:0.9;">Total Subscribed</div>
                </td>
                <td style="text-align:center;padding:14px;color:#fff;border-left:1px solid rgba(255,255,255,0.3);">
                  <div style="font-size:22px;font-weight:700;">${totalUnsub}</div>
                  <div style="font-size:10px;opacity:0.9;">Total Unsubscribed</div>
                </td>
                <td style="text-align:center;padding:14px;color:#fff;border-left:1px solid rgba(255,255,255,0.3);">
                  <div style="font-size:22px;font-weight:700;">${subRate}%</div>
                  <div style="font-size:10px;opacity:0.9;">Subscription Rate</div>
                </td>
              </tr>
            </table>
          </div>

          <!-- REVENUE & BILLING -->
          <div class="section">
            <div class="section-title">Revenue &amp; Billing</div>
            ${buildStatGrid(revenueStats)}
          </div>

          <div class="page-break"></div>

          <!-- POPULAR BUILDERS -->
          <div class="section">
            <div class="section-title">Popular Builders (Top 5)</div>
            ${topBuilders.length > 0
              ? buildPopularTable(['#','Builder Name','Reg. Agents','Total Bookings','Reg. Leads','Likes'],
                  topBuilders.map((b,i) => `<tr class="pt">
                    <td class="rank" style="width:28px;padding:7px 10px;font-size:11px;font-weight:700;color:#6F70FA;">${i+1}</td>
                    <td style="padding:7px 10px;font-size:11px;">${b.full_name||'N/A'}</td>
                    <td style="padding:7px 10px;font-size:11px;">${b.registered_agents||0}</td>
                    <td style="padding:7px 10px;font-size:11px;">${b.total_bookings||0}</td>
                    <td style="padding:7px 10px;font-size:11px;">${b.registered_leads||0}</td>
                    <td style="padding:7px 10px;font-size:11px;">${b.likes||0}</td>
                  </tr>`).join(''))
              : '<p style="color:#888;font-size:12px;margin-top:6px;">No builders data available</p>'}
          </div>

          <!-- POPULAR AGENTS -->
          <div class="section">
            <div class="section-title">Popular Agents (Top 5)</div>
            ${topAgents.length > 0
              ? buildPopularTable(['#','Agent Name','Total Bookings','Reg. Leads'],
                  topAgents.map((a,i) => `<tr>
                    <td style="width:28px;padding:7px 10px;font-size:11px;font-weight:700;color:#6F70FA;${i%2===1?'background:#F8F9FC;':''}">${i+1}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${a.full_name||'N/A'}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${a.total_bookings||0}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${a.registered_leads||0}</td>
                  </tr>`).join(''))
              : '<p style="color:#888;font-size:12px;margin-top:6px;">No agents data available</p>'}
          </div>

          <!-- POPULAR AGENCIES -->
          <div class="section">
            <div class="section-title">Popular Agencies (Top 5)</div>
            ${topAgencies.length > 0
              ? buildPopularTable(['#','Agency Name','Total Bookings','Reg. Leads'],
                  topAgencies.map((a,i) => `<tr>
                    <td style="width:28px;padding:7px 10px;font-size:11px;font-weight:700;color:#6F70FA;${i%2===1?'background:#F8F9FC;':''}">${i+1}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${a.full_name||a.agency_name||'N/A'}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${a.total_bookings||0}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${a.registered_leads||0}</td>
                  </tr>`).join(''))
              : '<p style="color:#888;font-size:12px;margin-top:6px;">No agencies data available</p>'}
          </div>

          <!-- POPULAR PROJECTS -->
          <div class="section">
            <div class="section-title">Popular Projects (Top 5)</div>
            ${topProjects.length > 0
              ? buildPopularTable(['#','Project Name','Location','Total Bookings','Reg. Leads','New Leads'],
                  topProjects.map((p,i) => `<tr>
                    <td style="width:28px;padding:7px 10px;font-size:11px;font-weight:700;color:#6F70FA;${i%2===1?'background:#F8F9FC;':''}">${i+1}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${p.project_name||'N/A'}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${[p.locality,p.city].filter(Boolean).join(', ')||'N/A'}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${p.total_bookings||0}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${p.registered_leads||0}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${p.new_leads||0}</td>
                  </tr>`).join(''))
              : '<p style="color:#888;font-size:12px;margin-top:6px;">No projects data available</p>'}
          </div>

          <div class="page-break"></div>

          <!-- POPULAR LOCATIONS -->
          <div class="section">
            <div class="section-title">Popular Locations (Top 5)</div>
            ${topLocations.length > 0
              ? buildPopularTable(['#','Location','No. of Projects','Total Bookings','Searches','Reg. Leads'],
                  topLocations.map((l,i) => `<tr>
                    <td style="width:28px;padding:7px 10px;font-size:11px;font-weight:700;color:#6F70FA;${i%2===1?'background:#F8F9FC;':''}">${i+1}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${[l.city,l.state].filter(Boolean).join(', ')||'N/A'}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${l.no_of_projects||0}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${l.total_bookings||0}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${l.searches||0}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${l.registered_leads||0}</td>
                  </tr>`).join(''))
              : '<p style="color:#888;font-size:12px;margin-top:6px;">No locations data available</p>'}
          </div>

          <!-- POPULAR PROPERTY TYPES -->
          <div class="section">
            <div class="section-title">Popular Property Types (Top 5)</div>
            ${topPropertyTypes.length > 0
              ? buildPopularTable(['#','Property Type','Total Projects','Total Bookings','Searches','Reg. Leads'],
                  topPropertyTypes.map((pt,i) => `<tr>
                    <td style="width:28px;padding:7px 10px;font-size:11px;font-weight:700;color:#6F70FA;${i%2===1?'background:#F8F9FC;':''}">${i+1}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${pt.property_type?pt.property_type.charAt(0).toUpperCase()+pt.property_type.slice(1):'N/A'}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${pt.total_projects||0}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${pt.total_bookings||0}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${pt.searches||0}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${pt.registered_leads||0}</td>
                  </tr>`).join(''))
              : '<p style="color:#888;font-size:12px;margin-top:6px;">No property types data available</p>'}
          </div>

          <!-- POPULAR COMMUNITY TYPES -->
          <div class="section">
            <div class="section-title">Popular Community Types (Top 5)</div>
            ${topCommunityTypes.length > 0
              ? buildPopularTable(['#','Community Type','Total Bookings','Searches','Reg. Leads'],
                  topCommunityTypes.map((ct,i) => `<tr>
                    <td style="width:28px;padding:7px 10px;font-size:11px;font-weight:700;color:#6F70FA;${i%2===1?'background:#F8F9FC;':''}">${i+1}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${ct.community_type?ct.community_type.charAt(0).toUpperCase()+ct.community_type.slice(1):'N/A'}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${ct.total_bookings||0}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${ct.searches||0}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${ct.registered_leads||0}</td>
                  </tr>`).join(''))
              : '<p style="color:#888;font-size:12px;margin-top:6px;">No community types data available</p>'}
          </div>

          <!-- POPULAR SPECS -->
          <div class="section">
            <div class="section-title">Popular Specs (Top 5)</div>
            ${topSpecs.length > 0
              ? buildPopularTable(['#','BHK Type','SFT Range','Total Bookings','Searches','Reg. Leads'],
                  topSpecs.map((s,i) => `<tr>
                    <td style="width:28px;padding:7px 10px;font-size:11px;font-weight:700;color:#6F70FA;${i%2===1?'background:#F8F9FC;':''}">${i+1}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${s.bhk_type||(s.bedrooms?s.bedrooms+' BHK':'N/A')}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${s.sft_range||'N/A'}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${s.total_bookings||0}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${s.searches||0}</td>
                    <td style="padding:7px 10px;font-size:11px;${i%2===1?'background:#F8F9FC;':''}">${s.registered_leads||0}</td>
                  </tr>`).join(''))
              : '<p style="color:#888;font-size:12px;margin-top:6px;">No specs data available</p>'}
          </div>

          <!-- FOOTER -->
          <div style="text-align:center;margin-top:28px;padding-top:18px;border-top:1px solid #E5E7EB;">
            <div style="font-size:10px;color:#888;">Report generated on ${currentDate}</div>
            <div style="font-size:10px;color:#888;margin-top:4px;">This is a system-generated document from REBAX Admin Platform</div>
          </div>

        </body>
        </html>
      `;

      const printIframe = document.createElement("iframe");
      printIframe.style.position = "fixed";
      printIframe.style.top = "-9999px";
      printIframe.style.left = "-9999px";
      printIframe.style.width = "1px";
      printIframe.style.height = "1px";
      printIframe.style.border = "none";
      document.body.appendChild(printIframe);
      printIframe.contentDocument.write(htmlContent);
      printIframe.contentDocument.close();
      setTimeout(() => {
        printIframe.contentWindow.focus();
        printIframe.contentWindow.print();
        printIframe.contentWindow.onafterprint = () => {
          document.body.removeChild(printIframe);
        };
        setTimeout(() => {
          if (document.body.contains(printIframe)) {
            document.body.removeChild(printIframe);
          }
        }, 3000);
      }, 500);
      console.log('✅ Admin Dashboard print dialog opened');
    } catch (error) {
      console.error('❌ PDF Error:', error);
      toast.error('Failed to generate PDF: ' + (error.message || 'Unknown error'));
    } finally {
      setIsGeneratingPDF(false);
    }
  };



  return (
    <div className="d-flex">
      <LeftNav />
      <div className="main-content flex-grow-1" style={{ overflow: "hidden" }}>
        <TopNav />
        <div className="p-4" style={{ overflowX: "hidden" }}>
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <div className="mt-3" style={{ color: '#888' }}>Loading...</div>
            </div>
          ) : (
        <div style={{border:"1px solid #E2E4E9",borderRadius:"10px", overflowX: "hidden"}} className="p-4">
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-4 ">
            <div className="dashboard-text px-3 mb-4">Dashboard</div>
            <div className="d-flex justify-content-center align-items-center">
              <button className="export-btn me-2" onClick={handleDownloadReport} disabled={isGeneratingPDF} style={{ opacity: isGeneratingPDF ? 0.7 : 1, cursor: isGeneratingPDF ? 'not-allowed' : 'pointer' }}>
                <img src={export1} alt="export" />
                <span className="export-text">Export</span>
              </button>
              <button
                className="export-btn me-2"
                onClick={() => setShowFilterModal(true)}
              >
                <img src={filter1} alt="filter" />
                <span className="export-text">Filters</span>
              </button>
            </div>
          </div>

          {/* Time Range Toggle Buttons (matches React Native app) */}
          <div className="card p-2 mb-4" style={{
            backgroundColor: 'rgb(242, 242, 242)',
            borderRadius: '24px',
            border: 'none'
          }}>
            <div className="d-flex gap-1">
              {['This Month', 'Previous Month', 'Life Time'].map((range) => (
                <button
                  key={range}
                  className={`btn flex-fill ${
                    timeRange === range
                      ? "text-white"
                      : "btn-link text-muted"
                  }`}
                  style={{
                    backgroundColor: timeRange === range ? '#18181B' : 'transparent',
                    border: 'none',
                    borderRadius: '16px',
                    fontSize: '11px',
                    fontWeight: timeRange === range ? '700' : '500',
                    minHeight: '36px',
                  }}
                  onClick={() => handleTimeRangePress(range)}
                >
                  {range}
                </button>
              ))}
            </div>
          </div>

          {/* Year Row with Filter (matches React Native app) */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h5 className="mb-0" style={{
              fontSize: '18px',
              fontWeight: 'bold',
              color: 'black'
            }}>
              {getTimeRangeDisplayText()}
            </h5>
          </div>

          {/* Stat Cards - API Driven (matches React Native app) */}
          {error ? (
            <div className="row g-4 mb-4">
              <div className="col-12">
                <div className="alert alert-danger d-flex align-items-center" role="alert">
                  <div className="me-3">❌</div>
                  <div>
                    <h6 className="mb-1">Failed to Load Data</h6>
                    <p className="mb-1">{error}</p>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => window.location.reload()}
                    >
                      Retry
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="row g-4 mb-4">
              {statConfig.map((stat) => (
                <div key={stat.key} className="col-lg-4 col-md-6 col-12">
                  <div className="card stat-card">
                    <div className="card-body d-flex flex-column justify-content-between h-100">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="lead-label">{stat.label}</div>
                        <img src={stat.img} alt={stat.label} width="40" />
                      </div>
                      <div className="stats-value">
                        {getDashboardValue(stat.key)}
                      </div>
                      <div className="stats-small">{getTimeRangeDisplayText()}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Subscription Section (matches React Native app) */}
          <h5 className="mb-3" style={{ color: "black", fontSize: "18px", fontWeight: "500" }}>
            Subscription
          </h5>
          <div className="row g-4 mb-4">
              <div className="col-lg-4 col-md-6 col-12">
                <div className="card stat-card">
                  <div className="card-body d-flex flex-column justify-content-between h-100">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="lead-label">Subscribed Builders</div>
                      <img src={activeleads} alt="Subscribed Builders" width="40" />
                    </div>
                    <div className="stats-value">{getDashboardValue('subscribed_builders')}</div>
                    <div className="stats-small">{getTimeRangeDisplayText()}</div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="card stat-card">
                  <div className="card-body d-flex flex-column justify-content-between h-100">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="lead-label">Subscribed Agents</div>
                      <img src={prospectleads} alt="Subscribed Agents" width="40" />
                    </div>
                    <div className="stats-value">{getDashboardValue('subscribed_agents')}</div>
                    <div className="stats-small">{getTimeRangeDisplayText()}</div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="card stat-card">
                  <div className="card-body d-flex flex-column justify-content-between h-100">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="lead-label">Subscribed Agencies</div>
                      <img src={bookinglead} alt="Subscribed Agencies" width="40" />
                    </div>
                    <div className="stats-value">{getDashboardValue('subscribed_agencies')}</div>
                    <div className="stats-small">{getTimeRangeDisplayText()}</div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="card stat-card">
                  <div className="card-body d-flex flex-column justify-content-between h-100">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="lead-label">Unsubscribed Builders</div>
                      <img src={invoicesent} alt="Unsubscribed Builders" width="40" />
                    </div>
                    <div className="stats-value">{getDashboardValue('unsubscribed_builders')}</div>
                    <div className="stats-small">{getTimeRangeDisplayText()}</div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="card stat-card">
                  <div className="card-body d-flex flex-column justify-content-between h-100">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="lead-label">Unsubscribed Agents</div>
                      <img src={sitevisit} alt="Unsubscribed Agents" width="40" />
                    </div>
                    <div className="stats-value">{getDashboardValue('unsubscribed_agents')}</div>
                    <div className="stats-small">{getTimeRangeDisplayText()}</div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="card stat-card">
                  <div className="card-body d-flex flex-column justify-content-between h-100">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="lead-label">Unsubscribed Agencies</div>
                      <img src={totalleads} alt="Unsubscribed Agencies" width="40" />
                    </div>
                    <div className="stats-value">{getDashboardValue('unsubscribed_agencies')}</div>
                    <div className="stats-small">{getTimeRangeDisplayText()}</div>
                  </div>
                </div>
              </div>
            </div>

          {/* Inactive Users Section */}
          <h5 className="mb-3" style={{ color: "black", fontSize: "18px", fontWeight: "500" }}>
            Inactive
          </h5>
          <div className="row g-4 mb-4">
              <div className="col-lg-4 col-md-6 col-12">
                <div className="card stat-card">
                  <div className="card-body d-flex flex-column justify-content-between h-100">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="lead-label">Total Inactive Users</div>
                      <img src={invoicesent} alt="Total Inactive Users" width="40" />
                    </div>
                    <div className="stats-value">{getDashboardValue('inactive_users')}</div>
                    <div className="stats-small">{getTimeRangeDisplayText()}</div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="card stat-card">
                  <div className="card-body d-flex flex-column justify-content-between h-100">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="lead-label">Inactive Builders</div>
                      <img src={activeleads} alt="Inactive Builders" width="40" />
                    </div>
                    <div className="stats-value">{getDashboardValue('inactive_builders')}</div>
                    <div className="stats-small">{getTimeRangeDisplayText()}</div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="card stat-card">
                  <div className="card-body d-flex flex-column justify-content-between h-100">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="lead-label">Inactive Agents</div>
                      <img src={prospectleads} alt="Inactive Agents" width="40" />
                    </div>
                    <div className="stats-value">{getDashboardValue('inactive_agents')}</div>
                    <div className="stats-small">{getTimeRangeDisplayText()}</div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="card stat-card">
                  <div className="card-body d-flex flex-column justify-content-between h-100">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="lead-label">Inactive Agencies</div>
                      <img src={bookinglead} alt="Inactive Agencies" width="40" />
                    </div>
                    <div className="stats-value">{getDashboardValue('inactive_agencies')}</div>
                    <div className="stats-small">{getTimeRangeDisplayText()}</div>
                  </div>
                </div>
              </div>
            </div>

          {/* Credits Usage Section */}
          <h5 className="mb-3" style={{ color: "black", fontSize: "18px", fontWeight: "500" }}>
            Credits Usage
          </h5>
          <div className="row g-4 mb-4">
              <div className="col-lg-4 col-md-6 col-12">
                <div className="card stat-card">
                  <div className="card-body d-flex flex-column justify-content-between h-100">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="lead-label">Builders Bought Credits</div>
                      <img src={activeleads} alt="Builders Bought Credits" width="40" />
                    </div>
                    <div className="stats-value">{getDashboardValue('builders_purchased_credits')}</div>
                    <div className="stats-small">{getTimeRangeDisplayText()}</div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="card stat-card">
                  <div className="card-body d-flex flex-column justify-content-between h-100">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="lead-label">Total Credits</div>
                      <img src={prospectleads} alt="Total Credits" width="40" />
                    </div>
                    <div className="stats-value">{getDashboardValue('total_credits')}</div>
                    <div className="stats-small">{getTimeRangeDisplayText()}</div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="card stat-card">
                  <div className="card-body d-flex flex-column justify-content-between h-100">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="lead-label">Credits Used</div>
                      <img src={bookinglead} alt="Credits Used" width="40" />
                    </div>
                    <div className="stats-value">{getDashboardValue('total_credits_used')}</div>
                    <div className="stats-small">{getTimeRangeDisplayText()}</div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="card stat-card">
                  <div className="card-body d-flex flex-column justify-content-between h-100">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="lead-label">Credits Revenue</div>
                      <img src={invoicesent} alt="Credits Revenue" width="40" />
                    </div>
                    <div className="stats-value">
                      ₹{parseFloat(dashboardData?.credits_revenue || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </div>
                    <div className="stats-small">{getTimeRangeDisplayText()}</div>
                  </div>
                </div>
              </div>
            </div>

          {/* Revenue Card - Dynamic data from API (matching mobile app) */}
          <div className="overview-card revenue-card mb-4">
            <div className="overview-header">
              <span className="overview-label">Revenue</span>
              {dashboardData?.revenue_change !== 0 && (
                <span className={`revenue-percent ${(dashboardData?.revenue_change || 0) >= 0 ? 'positive' : 'negative'}`}>
                  {(dashboardData?.revenue_change || 0) >= 0 ? '↑' : '↓'} {Math.abs(dashboardData?.revenue_change || 0)}%
                </span>
              )}
            </div>
            <div className="revenue-amount">
              ₹{(dashboardData?.total_revenue || 0).toLocaleString('en-IN')}
            </div>
            <div className="revenue-subtitle">Total Revenue from Subscriptions</div>
          </div>

          {/* Invoices Overview Card - Dynamic data from API (matching mobile app exactly) */}
          {(() => {
            const raised = dashboardData?.total_invoices_raised || 0;
            const fulfilled = dashboardData?.invoices_fulfilled || 0;
            const fulfillPct = raised > 0 ? Math.round((fulfilled / raised) * 100) : 0;
            const agentRaised = dashboardData?.agent_raised || 0;
            const agentFulfilled = dashboardData?.agent_fulfilled || 0;
            const agentPct = agentRaised > 0 ? Math.round((agentFulfilled / agentRaised) * 100) : 0;
            const agencyRaised = dashboardData?.agency_raised || 0;
            const agencyFulfilled = dashboardData?.agency_fulfilled || 0;
            const agencyPct = agencyRaised > 0 ? Math.round((agencyFulfilled / agencyRaised) * 100) : 0;
            const builderRaised = dashboardData?.builder_raised || 0;
            const builderFulfilled = dashboardData?.builder_fulfilled || 0;
            const builderPct = builderRaised > 0 ? Math.round((builderFulfilled / builderRaised) * 100) : 0;
            const invoices_rased =  dashboardData?.agent_raised + dashboardData?.agency_raised;
             const invoices_fulfilled =  dashboardData?.agent_fulfilled + dashboardData?.agency_fulfilled
            return (
              <div className="overview-card invoices-card mb-4">
                <h3 className="invoices-title">Invoices Overview</h3>

                {/* Raised and Fulfilled boxes */}
                <div className="invoice-stats-row">
                  <div className="invoice-stat-box">
                    <div className="invoice-stat-value">{invoices_rased}</div>
                    <div className="invoice-stat-label">Total Invoices Raised</div>
                  </div>
                  <div className="invoice-stat-box">
                    <div className="invoice-stat-value">{invoices_fulfilled}</div>
                    <div className="invoice-stat-label">Invoices Fulfilled</div>
                  </div>
                </div>

                {/* Fulfillment Progress */}
                <div className="fulfillment-section2">
                  <div className="fulfillment-header2">
                    <span className="fulfillment-label2">Fulfillment Progress</span>
                    <span className="fulfillment-percentage2">{fulfillPct}% ({fulfilled} / {raised})</span>
                  </div>
                  <div className="progress-bar-container2">
                    <div className="progress-bar-fill2" style={{width: `${Math.min(fulfillPct, 100)}%`}}></div>
                  </div>
                </div>

                {/* Per-role breakdown: Agents, Agencies, Builders */}
                <div className="agents-agencies-row">
                  {/* Agents */}
                  <div className="agent-box-small">
                    <h4 className="agent-box-title">Agents</h4>
                    <div className="agent-detail-row">
                      <span>Raised</span>
                      <span className="agent-value">{agentRaised}</span>
                    </div>
                    <div className="agent-detail-row">
                      <span>Fulfilled</span>
                      <span className="agent-value">{agentFulfilled}</span>
                    </div>
                    <div className="agent-detail-row">
                      <span>Ratio</span>
                      <span className="agent-value">{agentPct}%</span>
                    </div>
                    <div className="ratio-bar purple-bar" style={{width: `${Math.min(agentPct, 100)}%`}}></div>
                  </div>

                  {/* Agencies */}
                  <div className="agent-box-small">
                    <h4 className="agent-box-title">Agencies</h4>
                    <div className="agent-detail-row">
                      <span>Raised</span>
                      <span className="agent-value">{agencyRaised}</span>
                    </div>
                    <div className="agent-detail-row">
                      <span>Fulfilled</span>
                      <span className="agent-value">{agencyFulfilled}</span>
                    </div>
                    <div className="agent-detail-row">
                      <span>Ratio</span>
                      <span className="agent-value">{agencyPct}%</span>
                    </div>
                    <div className="ratio-bar green-bar" style={{width: `${Math.min(agencyPct, 100)}%`}}></div>
                  </div>

                  {/* Builders */}
                  {/* <div className="agent-box-small">
                    <h4 className="agent-box-title">Builders</h4>
                    <div className="agent-detail-row">
                      <span>Raised</span>
                      <span className="agent-value">{builderRaised}</span>
                    </div>
                    <div className="agent-detail-row">
                      <span>Fulfilled</span>
                      <span className="agent-value">{builderFulfilled}</span>
                    </div>
                    <div className="agent-detail-row">
                      <span>Ratio</span>
                      <span className="agent-value">{builderPct}%</span>
                    </div>
                    <div className="ratio-bar orange-bar" style={{width: `${Math.min(builderPct, 100)}%`}}></div>
                  </div> */}
                </div>
              </div>
            );
          })()}

          {/* Charts */}
          <LeadAnalytics selectedTab={selectedTab} filters={{ startDate: customStartDate, endDate: customEndDate }} />
          

          {/* Popular Lists Section */}
          <div className="popular-lists-section">
            <h3 className="popular-lists-title">Popular Lists</h3>

            <div className="popular-list-item" onClick={() => navigate("/PopularBuilder")} cursor="pointer" >
              <div className="popular-icon-wrapper purple-icon"  >
                <img src={popularbuilder1} alt="Popular Builders" className="popular-icon" />
              </div>
              <div className="popular-content" >
                <div className="popular-name" >Popular Builders</div>
                <div className="popular-count">{popularCounts?.popular_builders?.label || '25 Active Projects'}</div>
              </div>
              <div className="popular-arrow">›</div>
            </div>

            <div className="popular-list-item" onClick={() => navigate("/PopularAgents")}>
              <div className="popular-icon-wrapper blue-icon">
                <img src={popularagents1} alt="Popular Agents" className="popular-icon" />
              </div>
              <div className="popular-content">
                <div className="popular-name">Popular Agents</div>
                <div className="popular-count">{popularCounts?.popular_agents?.label || '150 Bookings'}</div>
              </div>
              <div className="popular-arrow">›</div>
            </div>

            <div className="popular-list-item"  onClick={() => navigate("/PopularAgencies")} >
              <div className="popular-icon-wrapper purple-icon">
                <img src={popularagencies1} alt="Popular Agencies" className="popular-icon" />
              </div>
              <div className="popular-content">
                <div className="popular-name">Popular Agencies</div>
                <div className="popular-count">{popularCounts?.popular_agencies?.label || '45 Bookings'}</div>
              </div>
              <div className="popular-arrow">›</div>
            </div>

            <div className="popular-list-item"  onClick={() => navigate("/PopularProjects")}>
              <div className="popular-icon-wrapper blue-icon">
                <img src={popularprojects1} alt="Popular Projects" className="popular-icon" />
              </div>
              <div className="popular-content">
                <div className="popular-name">Popular Projects</div>
                <div className="popular-count">{popularCounts?.popular_projects?.label || '120 Bookings'}</div>
              </div>
              <div className="popular-arrow">›</div>
            </div>

            <div className="popular-list-item"  onClick={() => navigate("/PopularLocations")}>
              <div className="popular-icon-wrapper blue-icon">
                <img src={popularlocations1} alt="Popular Locations" className="popular-icon" />
              </div>
              <div className="popular-content">
                <div className="popular-name">Popular Locations</div>
                <div className="popular-count">{popularCounts?.popular_locations?.label || '30 Searches'}</div>
              </div>
              <div className="popular-arrow">›</div>
            </div>

            <div className="popular-list-item"  onClick={() => navigate("/Popularpropertytypes")}>
              <div className="popular-icon-wrapper purple-icon">
                <img src={propertytypes1} alt="Property Types" className="popular-icon" />
              </div>
              <div className="popular-content">
                <div className="popular-name">Property Types</div>
                <div className="popular-count">{popularCounts?.popular_property_types?.label || '8 Categories'}</div>
              </div>
              <div className="popular-arrow">›</div>
            </div>

            <div className="popular-list-item"  onClick={() => navigate("/Popularcommunitytypes")}>
              <div className="popular-icon-wrapper purple-icon">
                <img src={communitytypes1} alt="Community Types" className="popular-icon" />
              </div>
              <div className="popular-content">
                <div className="popular-name">Community Types</div>
                <div className="popular-count">{popularCounts?.popular_community_types?.label || '5 Types'}</div>
              </div>
              <div className="popular-arrow">›</div>
            </div>

            <div className="popular-list-item"onClick={() => navigate("/PopularPropertySpecs")} cursor="pointer" >
              <div className="popular-icon-wrapper blue-icon">
                <img src={propertyspecs1} alt="Property Specs" className="popular-icon" />
              </div>
              <div className="popular-content">
                <div className="popular-name">Property Specs</div>
                <div className="popular-count">{popularCounts?.popular_specs?.label || '12 Specifications'}</div>
              </div>
              <div className="popular-arrow">›</div>
            </div>

            {/* <button
              className="download-full-report-btn"
              onClick={handleDownloadReportTest}
              disabled={isGeneratingPDF}
              style={{
                opacity: isGeneratingPDF ? 0.7 : 1,
                cursor: isGeneratingPDF ? 'not-allowed' : 'pointer',
                marginRight: '10px'
              }}
            >
              {isGeneratingPDF ? (
                <>
                  <div className="spinner-border spinner-border-sm me-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  Generating PDF...
                </>
              ) : (
                'Download Test Report'
              )}
            </button> */}
            <button
              className="download-full-report-btn"
              onClick={handleDownloadReport}
              disabled={isGeneratingPDF}
              style={{
                opacity: isGeneratingPDF ? 0.7 : 1,
                cursor: isGeneratingPDF ? 'not-allowed' : 'pointer'
              }}
            >
              {isGeneratingPDF ? (
                <>
                  <div className="spinner-border spinner-border-sm me-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  Generating PDF...
                </>
              ) : (
                'Download Full Report'
              )}
            </button>
          </div>
        </div>
          )}

          {/* Filter Modal */}
{/* <Modal
  show={showFilterModal}
  onHide={() => setShowFilterModal(false)}
  centered
  dialogClassName="custom-filter-modal2"
>
  <Modal.Header>
    <Modal.Title>Filters</Modal.Title>
    <button
      className="btn-custom-close"
      onClick={() => setShowFilterModal(false)}
    >
      <img src={close} alt="Close" />
    </button>
  </Modal.Header>

  <Modal.Body>
    <label className="form-label">Filter by date</label>
    <div className="d-flex gap-3">
      <Form.Control
        type="date"
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
      />
      <Form.Control
        type="date"
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
      />
    </div>
  </Modal.Body>

  <Modal.Footer>
    <Button
      variant="outline-primary"
      className="btn-clear2"
      onClick={handleClearFilters}
    >
      Clear Filters
    </Button>
    <Button
      variant="primary"
      className="btn-apply2"
      onClick={handleApplyFilters}
    >
      Apply
    </Button>
  </Modal.Footer>
</Modal> */}
   <Modal
  show={showFilterModal}
  onHide={() => setShowFilterModal(false)}
  centered
  dialogClassName="custom-filter-modal2"
>
  <div className="filter-modal-content ">
    {/* Close Button */}
   
 
    {/* Title */}
    <div className="filter-title mb-4">Filters</div>
     <button
      className="filter-close-btn"
      onClick={() => setShowFilterModal(false)}
    >
      <img src={close} alt="close" />
    </button>
 
    {/* Date Filter */}
    <label className="filter-label mt-4 mb-3">Filter by date</label>
    <div className="filter-date-row">
 <div className="filter-date-field" onClick={(e) => openDatePicker("start", e)}>
  <span>{startDate || "Select Start Date"}</span>
  <img src={calendar} alt="calendar" className="calendar-icon" />
</div>

<div className="filter-date-field" onClick={(e) => openDatePicker("end", e)}>
  <span>{endDate || "Select End Date"}</span>
  <img src={calendar} alt="calendar" className="calendar-icon" />
</div>

{/* Active filter indicator (matching mobile app exactly) */}

 
</div>
 
 {customStartDate && customEndDate && (
  <div style={{ backgroundColor: '#F0EDFF', borderRadius: '8px', padding: '12px', marginBottom: '16px', display: 'flex', alignItems: 'center', marginTop: '16px' }}>
    <span style={{ fontSize: '18px', marginRight: '8px' }}>📅</span>
    <span style={{ color: '#555', fontSize: '13px' }}>
      Filtered: {startDate} - {endDate}
    </span>
  </div>
)}
    {/* Removed extra user filter fields - keeping only date filters */}
<div className="filter-footer">
  <button className="btn-clear2" onClick={handleClearFilters}>
    Clear Filters
  </button>
  <button className="btn-apply2" onClick={handleApplyFilters}>
    Apply
  </button>
</div>
 
{isDatePickerVisible &&
  createPortal(
    <>
      {/* 🔹 Full-page transparent dark background */}
      <div
        className="datepicker-fullscreen"
        onClick={() => setIsDatePickerVisible(false)}
      ></div>
 
      {/* 🔹 Your existing picker — unchanged */}
      <div
        className="datepicker-overlay"
        style={{
          top: pickerPosition.top,
          left: pickerPosition.left,
          width: pickerPosition.width,
          position: "absolute",
        }}
      >
        <div className="datepicker-box">
          <div className="selection-line m-3"></div>
 
          {/* Day */}
          <div
            className="datepicker-col"
            ref={dayRef}
            onScroll={() =>
              handleScroll(dayRef, setSelectedDayIdx, days.length)
            }
          >
            <div className="datepicker-item spacer"></div>
            {days.map((d, i) => (
              <div
                key={i}
                className={`datepicker-item ${
                  i === selectedDayIdx ? "selected" : ""
                }`}
              >
                {d}
              </div>
            ))}
            <div className="datepicker-item spacer"></div>
          </div>
 
          {/* Month */}
          <div
            className="datepicker-col"
            ref={monthRef}
            onScroll={() =>
              handleScroll(monthRef, setSelectedMonthIdx, months.length)
            }
          >
            <div className="datepicker-item spacer"></div>
            {months.map((m, i) => (
              <div
                key={i}
                className={`datepicker-item ${
                  i === selectedMonthIdx ? "selected" : ""
                }`}
              >
                {m}
              </div>
            ))}
            <div className="datepicker-item spacer"></div>
          </div>
 
          {/* Year */}
          <div
            className="datepicker-col"
            ref={yearRef}
            onScroll={() =>
              handleScroll(yearRef, setSelectedYearIdx, years.length)
            }
          >
            <div className="datepicker-item spacer"></div>
            {years.map((y, i) => (
              <div
                key={i}
                className={`datepicker-item ${
                  i === selectedYearIdx ? "selected" : ""
                }`}
              >
                {y}
              </div>
            ))}
            <div className="datepicker-item spacer"></div>
          </div>
 
          <div className="datepicker-actions">
            <button
              className="cancel-btn"
              onClick={() => setIsDatePickerVisible(false)}
            >
              Cancel
            </button>
            <button className="save-btn" onClick={handleSaveDate}>
              Save
            </button>
          </div>
        </div>
      </div>
    </>,
    document.body // ✅ renders outside modal container
  )}
 
  </div>
</Modal>
 




        </div>
      </div>
    </div>
  );
}
